import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse ,HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

@Injectable()
export class NovosNegociosProvider {

  apiRoot: string = 'http://192.99.185.73:8070';

  constructor(public http: HttpClient) {
    console.log('Hello NovosNegociosProvider Provider');
  }

  getNovosNegocios(CodigoVendedor: string, CategoryMLB: string, Limite: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this.http
      .get(this.apiRoot + '/Vendedor/ListarNovosNegocios?codigosVendedor=' + CodigoVendedor + '&categoriaMLB=' + CategoryMLB + '&limit=' + Limite, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  exportNovosNegocios(CodigoVendedor: string, CategoryMLB: string, Limite: string){

    const header = new HttpHeaders({'Content-Type':  'application/octet-stream', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this.http
      .get(this.apiRoot + '/Vendedor/ExportarRelatorioNovosNegocios?codigosVendedor=' + CodigoVendedor + '&categoriaMLB=' + CategoryMLB + '&limit=' + Limite, { headers: header, responseType: 'blob'})

      .do(blob => blob)
      .catch(this.handleError);
  }

  putRevisarNovosNegocios(Codigo: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let Email = localStorage.getItem('userLogin');

    return this.http
      .post(this.apiRoot + '/Anuncios/RevisarNovosNegocios?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);

  }

  putNovosNegocios(Codigo: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let Email = localStorage.getItem('userLogin');

    return this.http
      .post(this.apiRoot + '/Anuncios/InserirNovosNegocios?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  inserirNovosNegocios(Codigo: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let Email = localStorage.getItem('userLogin');

    return this.http
      .post(this.apiRoot + '/Anuncios/InserirNovosNegocios?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  revisarNovosNegocios(Codigo: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let Email = localStorage.getItem('userLogin');

    return this.http
      .post(this.apiRoot + '/Anuncios/RevisarNovosNegocios?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }


  private handleError(error: HttpErrorResponse){

    let errorMessage = {};
    if (error.error instanceof Error) {
        // A client-side or network error occurred. Handle it accordingly.
        errorMessage = `An error occurred: ${error.error.message}`;
        console.log(error.error);

    } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        errorMessage = { status: error.status, message: error.error.Message };
        console.log(error.error);

        if(error.status == 401){

        }

    }

    return Observable.throw(errorMessage);
  }

}



// WEBPACK FOOTER //
// ./src/providers/novos-negocios/novos-negocios.ts